<template>
  <div style="background-color: #fafafa; padding: 20px;">
    <div class="review-header">
      <div>
        <p>평점 평균</p>
        <p class="header-number">{{averageRating}}</p>
        <star-rating
          :increment="0.5"
          :rating="averageRating"
          :read-only="true"
          :star-size="20"
          :show-rating="false"
        ></star-rating>
      </div>
      <div>
        <p>실시간 무료체험 중</p>
        <p class="header-number">{{freetrialNumber}}</p>
      </div>
    </div>
    <div class="review-body">
      <div v-for="(review, index) in reviews" v-bind:key="index" class="review-box">
        <div class="review-contents-left">{{review.name}}</div>
        <div class="review-contents-right">
          <star-rating :rating="review.rate" :read-only="true" :star-size="12" :show-rating="true"></star-rating>
          <p class="product-name">{{productName}}</p>
          <p>{{review.content}}</p>
          <p class="product-name">{{review.created_at}}</p>
        </div>
      </div>
    </div>
    <div class="review-footer">
      <button @click="loadMoreReviewClick">리뷰 더보기</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'review',
  props: ['reviews', 'productName', 'averageRating', 'freetrialNumber'],
  methods: {
    loadMoreReviewClick: function () {
      this.$emit('loadReview')
    }
  }
}
</script>
<style>
.review-header {
  display: flex;
  justify-content: space-around;
  padding: 20px;
}
.header-number {
  font-size: 30px;
  margin-bottom: 0;
}
.review-box {
  display: flex;
  padding: 10px;
  /* border: 1px solid black; */
  margin-bottom: 10px;
  background-color: #ffffff;
  border: .5px solid #f1f5f7;
  box-shadow: 0 1px 1px 0 #e9ecee;
}
.review-contents-left {
  width: 60px;
  display: flex;
  align-items: center;
}
.review-contents-right {
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
}
.product-name {
  color: #bbb;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/products/Review.vue